import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './components/I18nProvider';
import MainPage from './app/page';
import DashboardPage from './app/dashboard/page';

function App() {
  return (
    <div className="font-inter">
      <I18nProvider>
        <Router>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
          </Routes>
        </Router>
      </I18nProvider>
    </div>
  );
}

export default App; 